import axios from "axios";

const API = "https://mocaub1h8d.execute-api.us-east-1.amazonaws.com/prod";

const token = () => localStorage.getItem("sinin_token") || "";

const headers = () => ({
  Authorization: `Bearer ${token()}`,
});

const post = (endpoint, data) =>
  axios.post(`${API}/${endpoint}`, data, { headers: headers() }).then(r => r.data);

// ── Auth ──────────────────────────────────────────────────────────────────────
export const login = (dni, password) =>
  post("sinin_login", { dni, password });

export const loginEmpresaAdmin = (empresaId, dni, password) =>
  post("sinin_login", { empresaId, dni, password, scope: "admin" });

export const loginVendedor = (empresaId, dni, password) =>
  post("sinin_login", { empresaId, dni, password, scope: "rrpp" });

export const loginScannerUsuario = (empresaId, dni, password) =>
  post("sinin_login", { empresaId, dni, password, scope: "scanner" });

// ── Eventos ───────────────────────────────────────────────────────────────────
export const getEventos = (empresaId, loginType = "0") =>
  post("sinin_getEventos", { empresaId, loginType });

export const crearEvento = (empresaId, data) =>
  post("sinin_gestionarEventos", { accion: "crear", empresaId, ...data });

export const editarEvento = (empresaId, data) =>
  post("sinin_gestionarEventos", { accion: "editar", empresaId, ...data });

export const eliminarEvento = (empresaId, idEvento) =>
  post("sinin_gestionarEventos", { accion: "eliminar", empresaId, idEvento });

export const getEmpresaConfig = empresaId =>
  post("sinin_gestionarEmpresas", { action: "get", empresaId });

export const getEmpresaBrand = empresaId =>
  post("sinin_gestionarEmpresas", { action: "public_brand", empresaId });

export const guardarMercadoPago = (empresaId, mercadoPago) =>
  post("sinin_gestionarEmpresas", {
    action: "update_mp",
    empresaId,
    mercadoPago,
  });

export const guardarEmailEmpresa = (empresaId, mailConfig) =>
  post("sinin_gestionarEmpresas", {
    action: "update_mail",
    empresaId,
    mailConfig,
  });

// ── Entradas ──────────────────────────────────────────────────────────────────
export const getEntradas = (empresaId, filtros = {}) =>
  post("sinin_getEntradas", { empresaId, ...filtros });

export const registerEntradas = (entradas) =>
  post("sinin_registerEntradas", entradas);

export const eliminarEntrada = (empresaId, hashSeguro, createdBy) =>
  post("sinin_registerEntradas", {
    accion: "eliminar",
    empresaId,
    hashSeguro,
    createdBy,
  });

export const reenviarEntrada = (empresaId, hashSeguro, createdBy, email = "") =>
  post("sinin_registerEntradas", {
    empresaId,
    hashSeguro,
    createdBy,
    email,
    accion: "reenviar",
  });

export const reenviarEntradasLote = (empresaId, hashes, createdBy, email) =>
  post("sinin_registerEntradas", {
    accion: "reenviar_lote",
    empresaId,
    hashes,
    createdBy,
    email,
  });

// ── RRPP ──────────────────────────────────────────────────────────────────────
export const getRRPP = (empresaId) =>
  post("sinin_registerRRPP", { action: "list", empresaId });

export const crearRRPP = (empresaId, data) =>
  post("sinin_registerRRPP", { action: "create", empresaId, ...data });

export const editarRRPP = (empresaId, data) =>
  post("sinin_registerRRPP", { action: "update", empresaId, ...data });

export const eliminarRRPP = (empresaId, dni) =>
  post("sinin_registerRRPP", { action: "delete", empresaId, dni });

// ── Usuarios scanner (viven en USERS, no en RRPP) ─────────────────────────────
export const getScanners = (empresaId) =>
  post("sinin_gestionarEmpresas", { action: "scanner_users_list", empresaId });

export const guardarScanner = (empresaId, data) =>
  post("sinin_gestionarEmpresas", { action: "scanner_user_upsert", empresaId, ...data });

export const eliminarScanner = (empresaId, dni) =>
  post("sinin_gestionarEmpresas", { action: "scanner_user_delete", empresaId, dni });

// ── QR ────────────────────────────────────────────────────────────────────────
export const validateQR = (empresaId, hashSeguro, scanner = {}) =>
  post("sinin_validateQR", { empresaId, hashSeguro, ...scanner });

// ── Logo ──────────────────────────────────────────────────────────────────────
export const uploadLogo = (empresaId, fileB64, filename) =>
  post("sinin_uploadLogo", { empresaId, file_b64: fileB64, filename });

export const uploadEventGuestLogo = (empresaId, eventId, slot, fileB64, filename) =>
  post("sinin_uploadLogo", {
    empresaId, eventId, slot, file_b64: fileB64, filename, purpose: "invitan",
  });

// ── Scanner de puerta ────────────────────────────────────────────────────────
export const scannerEmpresas = () =>
  post("sinin_gestionarEmpresas", { action: "scanner_list" });

export const scannerLogin = (empresaId, scannerPass) =>
  post("sinin_gestionarEmpresas", { action: "scanner_login", empresaId, scannerPass });

// ── Compradores / Mercado Pago ────────────────────────────────────────────────
export const compradorPublicConfig = (empresaId) =>
  post("sinin_compradores", { action: "public_config", empresaId });

export const compradorEventos = (empresaId) =>
  post("sinin_compradores", { action: "eventos_publicos", empresaId });

export const compradorRegister = (data) =>
  post("sinin_compradores", { action: "register", ...data });

export const compradorLogin = (data) =>
  post("sinin_compradores", { action: "login", ...data });

export const compradorCreateOrder = (data) =>
  post("sinin_compradores", { action: "create_order", ...data });

export const compradorMisTickets = (data) =>
  post("sinin_compradores", { action: "mis_tickets", ...data });


// ── Waitlist (lista de espera) ────────────────────────────────────────────────
const postPublic = (endpoint, data) =>
  axios.post(`${API}/${endpoint}`, data).then(r => r.data);

export const waitlistSubmit = (data) =>
  postPublic("sinin_waitlist", { action: "submit", ...data });

export const waitlistList = (empresaId, eventoId) =>
  post("sinin_waitlist", { action: "list", empresaId, eventoId });

export const waitlistApprove = (empresaId, id) =>
  post("sinin_waitlist", { action: "approve", empresaId, id });

export const waitlistReject = (empresaId, id) =>
  post("sinin_waitlist", { action: "reject", empresaId, id });

export const waitlistStatus = (empresaId, eventoId, id, dni) =>
  postPublic("sinin_waitlist", { action: "status", empresaId, eventoId, id, dni });

export const waitlistUpdate = (empresaId, id, data) =>
  post("sinin_waitlist", { action: "update", empresaId, id, ...data });
